






























































































































































import { ParamsReloadType } from "@/enums/enums";
import { CheckIsDevelop } from "@/helper/shareHelper";
import { MerchantId } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";
const isDevelop = CheckIsDevelop();
@Component
export default class MainNavbar extends Vue {
  created() {
    this.listMenu = this.SetListMenu();
  }

  private listMenu: Array<any> = [];
  private Emi = 10;

  public SetListMenu() {
    const lislMenu = [
      {
        name: "Menu_Dashboard",
        icon: "",
        img: require("@/assets/img/menubar/ic_dashboard.png"),
        link: { name: "home" },
        canNotAccess: !this.$can("access", "Dashboard"),
      },
      {
        name: "Menu_Custom",
        icon: "",
        img: require("@/assets/img/menubar/ic_custom.png"),
        link: { name: "custom" },
      },
      {
        name: "Menu_Follow",
        icon: "",
        img: require("@/assets/img/menubar/ic_follow.png"),
        link: { name: "" },
        lock: { value: true, text: "Lock_HeaderMenu" },
      },
      {
        name: "Menu_Analyst",
        icon: "",
        img: require("@/assets/img/menubar/ic_analyst.png"),
        link: { name: "executiveSummary" },
      },
      {
        name: "Menu_Setting",
        icon: "",
        img: require("@/assets/img/menubar/ic_setting.png"),
        link: { name: "" },
        lock: { value: true, text: "Lock_HeaderMenu" },
      },
    ];
    return lislMenu;
  }

  public checkActiveMenu(linkName: any) {
    if (linkName && this.$route.matched.length > 0) {
      if (linkName.name == this.$route.matched[0].name) {
        return true;
      } else {
        return false;
      }
    }
  }

  public SetQueryURL() {
    const query = {
      emi: MerchantId().PeakEncryption(),
      reload: ParamsReloadType.Reload,
    };

    return query;
  }
}
